const faqs = [
  {
    q: 'YY漫画网的漫画都是免费的吗？',
    a: '是的，YY漫画网上的所有漫画均支持免费在线观看。我们提供全集漫画免费下拉式阅读，无需付费订阅，打开网页即可畅享韩漫、日漫、国漫的精彩内容。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '热门漫画每日同步更新，紧跟原作连载节奏。韩漫、日漫、国漫各分类的更新快讯会在首页实时展示，漫画排行榜也会同步刷新，确保你不错过任何最新话。',
  },
  {
    q: '如何找到自己喜欢的漫画类型？',
    a: '你可以通过首页的话题分类标签快速筛选感兴趣的类型，也可以参考漫画排行榜和专题推荐。我们还提供详细的漫画分类浏览功能，涵盖热血、恋爱、奇幻、悬疑等多种题材。',
  },
  {
    q: '手机上看漫画体验如何？',
    a: 'YY漫画网全设备完美适配，手机端下拉式阅读体验流畅自然。无需下载任何APP，在手机浏览器中打开网站即可开始阅读，随时随地免费在线看漫画。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问答
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            关于YY漫画网你想了解的问题都在这里
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-sm font-bold">Q</span>
                </span>
                {faq.q}
              </h3>
              <div className="flex items-start gap-3 pl-9">
                <span className="w-5 h-5 rounded-full bg-accent-100 text-accent-600 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-xs font-bold">A</span>
                </span>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}